// extracted by mini-css-extract-plugin
export default {"ContentArea":"ContentArea_ContentArea__RnNN1","materialGrid":"ContentArea_materialGrid__laFww"};